import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "designated-driving"
};
const _hoisted_2 = {
  class: "main-wrap return-trip-wrap"
};
const _hoisted_3 = {
  id: "positionMap"
};
const _hoisted_4 = {
  key: 1,
  class: "van-list"
};
const _hoisted_5 = {
  key: 0,
  class: "order-card-cell-tag wait"
};
const _hoisted_6 = {
  key: 1,
  class: "order-card-cell-tag pending"
};
const _hoisted_7 = {
  key: 2,
  class: "order-card-cell-tag pending"
};
const _hoisted_8 = {
  key: 3,
  class: "order-card-cell-tag progressing"
};
const _hoisted_9 = {
  key: 4,
  class: "order-card-cell-tag progressing"
};
const _hoisted_10 = {
  key: 5,
  class: "order-card-cell-tag payment"
};
const _hoisted_11 = {
  key: 6,
  class: "order-card-cell-tag cancel"
};
const _hoisted_12 = {
  key: 7,
  class: "order-card-cell-tag wait"
};
const _hoisted_13 = {
  class: "order-info"
};
const _hoisted_14 = {
  class: "order-info-item"
};
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_16 = {
  class: "text"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("small", {
  style: {
    "margin-right": "5px"
  }
}, "出发", -1);
const _hoisted_18 = {
  class: "order-info-item"
};
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_20 = {
  class: "text"
};
const _hoisted_21 = /*#__PURE__*/_createElementVNode("small", {
  style: {
    "margin-right": "5px"
  }
}, "前往", -1);
const _hoisted_22 = {
  class: "order-info-item"
};
const _hoisted_23 = {
  class: "designated-driving-wrap"
};
const _hoisted_24 = {
  class: "van-list"
};
const _hoisted_25 = {
  class: "card order-card"
};
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_27 = {
  key: 0,
  class: "card order-card"
};
const _hoisted_28 = {
  key: 0,
  class: "order-card-cell-tag wait"
};
const _hoisted_29 = {
  key: 1,
  class: "order-card-cell-tag pending"
};
const _hoisted_30 = {
  key: 2,
  class: "order-card-cell-tag pending"
};
const _hoisted_31 = {
  key: 3,
  class: "order-card-cell-tag progressing"
};
const _hoisted_32 = {
  key: 4,
  class: "order-card-cell-tag progressing"
};
const _hoisted_33 = {
  key: 5,
  class: "order-card-cell-tag payment"
};
const _hoisted_34 = {
  key: 6,
  class: "order-card-cell-tag wait"
};
const _hoisted_35 = {
  class: "order-info"
};
const _hoisted_36 = {
  class: "order-info-item order-time"
};
const _hoisted_37 = {
  class: "icon"
};
const _hoisted_38 = {
  class: "text"
};
const _hoisted_39 = /*#__PURE__*/_createElementVNode("small", {
  style: {
    "margin-right": "5px"
  }
}, " 出发时间 ", -1);
const _hoisted_40 = {
  class: "order-info-item"
};
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
})], -1);
const _hoisted_42 = {
  class: "text"
};
const _hoisted_43 = /*#__PURE__*/_createElementVNode("small", {
  style: {
    "margin-right": "5px"
  }
}, " 出发地点 ", -1);
const _hoisted_44 = {
  class: "order-info-item"
};
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "icon"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
})], -1);
const _hoisted_46 = {
  class: "text"
};
const _hoisted_47 = /*#__PURE__*/_createElementVNode("small", {
  style: {
    "margin-right": "5px"
  }
}, " 目的地点 ", -1);
const _hoisted_48 = {
  class: "order-info-item"
};
const _hoisted_49 = {
  class: "icon"
};
const _hoisted_50 = {
  class: "text"
};
const _hoisted_51 = /*#__PURE__*/_createElementVNode("small", {
  style: {
    "margin-right": "5px"
  }
}, " 预估价格 ", -1);
const _hoisted_52 = {
  key: 1,
  class: "card order-card"
};
const _hoisted_53 = {
  class: "order-info"
};
const _hoisted_54 = {
  class: "order-info-item"
};
const _hoisted_55 = {
  class: "icon"
};
const _hoisted_56 = {
  class: "text"
};
const _hoisted_57 = {
  style: {
    "margin-left": "5px"
  }
};
const _hoisted_58 = {
  key: 0,
  class: "order-info-item"
};
const _hoisted_59 = {
  class: "icon"
};
const _hoisted_60 = {
  class: "text"
};
const _hoisted_61 = {
  key: 0,
  class: "designated-driving-wrap"
};
const _hoisted_62 = {
  key: 1,
  class: "designated-driving-wrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_designated_driving_passenger_form = _resolveComponent("designated-driving-passenger-form");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  const _component_van_time_picker = _resolveComponent("van-time-picker");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_nav_bar, {
    class: "return-trip-nav-bar",
    title: $setup.title,
    border: false
  }, null, 8, ["title"]), _createVNode(_component_van_tabs, {
    color: "#1989FA",
    active: $setup.tabActive,
    "onUpdate:active": _cache[1] || (_cache[1] = $event => $setup.tabActive = $event),
    onClickTab: $options.tabClick,
    swipeable: ""
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [[_vShow, false]]), _createVNode(_component_van_tab, {
      title: "历史代驾"
    }, {
      default: _withCtx(() => [!$setup.orders || $setup.orders.length === 0 ? (_openBlock(), _createBlock(_component_van_empty, {
        key: 0,
        description: "暂无代驾订单"
      })) : _createCommentVNode("", true), $setup.orders && $setup.orders.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.orders, (order, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "card order-card on-designated-driving",
          key: index
        }, [_createVNode(_component_van_cell, null, {
          value: _withCtx(() => [order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_WAITING' || order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock("div", _hoisted_5, " 预定中 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_PENDING' ? (_openBlock(), _createElementBlock("div", _hoisted_6, "候驾中 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_ARRIVED_PICK_UP' ? (_openBlock(), _createElementBlock("div", _hoisted_7, "待上车 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "行程中 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_ARRIVED_DROP_OFF' ? (_openBlock(), _createElementBlock("div", _hoisted_9, "已到达 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", _hoisted_10, "待付款 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_CANCEL' ? (_openBlock(), _createElementBlock("div", _hoisted_11, "已关闭 ")) : _createCommentVNode("", true), order.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_COMPLETED' ? (_openBlock(), _createElementBlock("div", _hoisted_12, "已完成 ")) : _createCommentVNode("", true)]),
          title: _withCtx(() => [_createTextVNode(_toDisplayString($options.CommonUtil.formatDate(order.departure_time, "MM月DD日 HH:mm")), 1)]),
          _: 2
        }, 1024), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("strong", null, _toDisplayString(order.departure_address_description), 1)])]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("strong", null, _toDisplayString(order.destination_address_description), 1)])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_van_tag, {
          type: "danger",
          plain: "",
          style: {
            "margin-right": "8px"
          }
        }, {
          default: _withCtx(() => [_createElementVNode("small", null, "预估 ￥" + _toDisplayString(order.estimated_cost), 1)]),
          _: 2
        }, 1024), _createVNode(_component_van_tag, {
          type: "primary",
          plain: ""
        }, {
          default: _withCtx(() => [_createElementVNode("small", null, "共 " + _toDisplayString(order.seats_count) + " 人", 1)]),
          _: 2
        }, 1024)])])]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_23, [_createVNode(_component_van_button, {
        class: "designated-driving-button",
        type: "primary",
        block: "",
        onClick: $options.designatedDrivingPublish
      }, {
        default: _withCtx(() => [_createTextVNode(" 我要找代驾 ")]),
        _: 1
      }, 8, ["onClick"])])]),
      _: 1
    }), _createVNode(_component_van_tab, {
      title: "我的代驾"
    }, {
      default: _withCtx(() => {
        var _$setup$status;
        return [_withDirectives(_createVNode(_component_van_empty, {
          description: "暂无正在进行的代驾"
        }, null, 512), [[_vShow, !$setup.status]]), _withDirectives(_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_van_cell, {
          title: "代驾地图"
        }, {
          value: _withCtx(() => [_createElementVNode("div", {
            class: "order-card-cell-button default",
            onClick: _cache[0] || (_cache[0] = $event => $options.getStatus(false, true))
          }, "刷新状态")]),
          _: 1
        }), _hoisted_26]), $setup.status ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_van_cell, {
          title: "代驾状态"
        }, {
          value: _withCtx(() => [$setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_WAITING' || $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_CONFIRMING' ? (_openBlock(), _createElementBlock("div", _hoisted_28, " 预定中 ")) : _createCommentVNode("", true), $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_PENDING' ? (_openBlock(), _createElementBlock("div", _hoisted_29, "候驾中 ")) : _createCommentVNode("", true), $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_ARRIVED_PICK_UP' ? (_openBlock(), _createElementBlock("div", _hoisted_30, "待上车 ")) : _createCommentVNode("", true), $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_PROGRESSING' ? (_openBlock(), _createElementBlock("div", _hoisted_31, "行程中 ")) : _createCommentVNode("", true), $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_ARRIVED_DROP_OFF' ? (_openBlock(), _createElementBlock("div", _hoisted_32, "已到达 ")) : _createCommentVNode("", true), $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", _hoisted_33, "待付款 ")) : _createCommentVNode("", true), $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_COMPLETED' ? (_openBlock(), _createElementBlock("div", _hoisted_34, " 已完成 ")) : _createCommentVNode("", true)]),
          _: 1
        }), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_van_icon, {
          name: "underway",
          size: "13px",
          color: "#1989fa"
        })]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatDate($setup.status.departure_time, "MM月DD日 HH:mm")), 1)])]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("div", _hoisted_42, [_hoisted_43, _createElementVNode("strong", null, _toDisplayString($setup.status.departure_address_description), 1)])]), _createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, [_hoisted_47, _createElementVNode("strong", null, _toDisplayString($setup.status.destination_address_description), 1)])]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createVNode(_component_van_icon, {
          name: "gold-coin",
          size: "13px",
          color: "#FF0080"
        })]), _createElementVNode("div", _hoisted_50, [_hoisted_51, _createElementVNode("strong", null, "￥" + _toDisplayString($setup.status.estimated_cost), 1)])])])])) : _createCommentVNode("", true), (_$setup$status = $setup.status) !== null && _$setup$status !== void 0 && _$setup$status.driver_info ? (_openBlock(), _createElementBlock("div", _hoisted_52, [_createVNode(_component_van_cell, {
          title: "司机信息",
          value: "联系司机",
          "is-link": ""
        }), _createElementVNode("div", _hoisted_53, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createVNode(_component_van_icon, {
          name: "manager",
          color: "#0055ff"
        })]), _createElementVNode("div", _hoisted_56, [_createElementVNode("strong", null, _toDisplayString($setup.status.driver_info.name), 1), _createElementVNode("small", _hoisted_57, _toDisplayString($setup.status.driver_info.phone_number), 1)])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_van_icon, {
          name: "phone",
          color: "#1989FA"
        })]), _createElementVNode("div", _hoisted_60, _toDisplayString($setup.status.driver_info.phone_number), 1)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)], 512), [[_vShow, $setup.status]]), !$setup.status ? (_openBlock(), _createElementBlock("div", _hoisted_61, [_createVNode(_component_van_button, {
          class: "designated-driving-button",
          type: "primary",
          block: "",
          onClick: $options.designatedDrivingPublish
        }, {
          default: _withCtx(() => [_createTextVNode(" 我要找代驾 ")]),
          _: 1
        }, 8, ["onClick"])])) : _createCommentVNode("", true), $setup.status ? (_openBlock(), _createElementBlock("div", _hoisted_62, [_createVNode(_component_van_button, {
          loading: $setup.submitLoading,
          class: "designated-driving-button",
          type: "primary",
          block: "",
          disabled: !($setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_WAITING' || $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_CONFIRMING' || $setup.status.order_status === 'DESIGNATED_DRIVING_ORDER_STATUS_PENDING'),
          onClick: $options.designatedDrivingCancel
        }, {
          default: _withCtx(() => [_createTextVNode(" 关闭代驾 ")]),
          _: 1
        }, 8, ["loading", "disabled", "onClick"])])) : _createCommentVNode("", true)];
      }),
      _: 1
    })]),
    _: 1
  }, 8, ["active", "onClickTab"])]), _createVNode(_component_van_popup, {
    show: $setup.showReturnTripPassengerForm,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $setup.showReturnTripPassengerForm = $event),
    closeable: "",
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_designated_driving_passenger_form, {
      ref: "designatedDrivingPassengerForm",
      "user-data": $setup.userData,
      adcode: $setup.cityCode,
      "start-province": $setup.startProvince,
      "start-city": $setup.startCity,
      "start-district": $setup.startDistrict,
      "start-address": $setup.startAddress,
      "start-position": $setup.startPosition,
      "end-position": $setup.endPosition,
      "show-departure-time-date-picker-click": $options.showDepartureTimeDatePickerClick,
      "return-trip-passenger-form-success": $options.returnTripPassengerFormSuccess
    }, null, 8, ["user-data", "adcode", "start-province", "start-city", "start-district", "start-address", "start-position", "end-position", "show-departure-time-date-picker-click", "return-trip-passenger-form-success"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDepartureTimeDatePicker,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $setup.showDepartureTimeDatePicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_date_picker, {
      modelValue: $setup.departure_time_date,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.departure_time_date = $event),
      title: "选择日期",
      "min-date": new Date(),
      onConfirm: $options.confirmDepartureTimeDatePicker,
      onCancel: _cache[4] || (_cache[4] = $event => $setup.showDepartureTimeDatePicker = false)
    }, null, 8, ["modelValue", "min-date", "onConfirm"])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDepartureTimeHourMinPicker,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.showDepartureTimeHourMinPicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_time_picker, {
      modelValue: $setup.departure_time_hour_min,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.departure_time_hour_min = $event),
      title: "选择时间",
      "min-date": new Date(),
      onConfirm: $options.confirmDepartureTimeHourMinPicker,
      onCancel: _cache[7] || (_cache[7] = $event => $setup.showDepartureTimeHourMinPicker = false)
    }, null, 8, ["modelValue", "min-date", "onConfirm"])]),
    _: 1
  }, 8, ["show"])]);
}